export const GET_BUSINESS_COLOR_PALETTES = "GET_BUSINESS_COLOR_PALETTES"
export const GET_BUSINESS_COLOR_PALETTES_SUCCESS = "GET_BUSINESS_COLOR_PALETTES_SUCCESS"
export const GET_PUBLIC_COLOR_PALETTES = "GET_PUBLIC_COLOR_PALETTES"
export const GET_PUBLIC_COLOR_PALETTES_SUCCESS = "GET_PUBLIC_COLOR_PALETTES_SUCCESS"
export const GET_COLOR_PALETTE = "GET_COLOR_PALETTE"
export const GET_COLOR_PALETTE_SUCCESS = "GET_COLOR_PALETTE_SUCCESS"
export const POST_COLOR_PALETTE = "POST_COLOR_PALETTE"
export const POST_COLOR_PALETTE_SUCCESS = "POST_COLOR_PALETTE_SUCCESS"
export const RESET_POSTED_COLOR_PALETTE = "RESET_POSTED_COLOR_PALETTE"
export const PATCH_COLOR_PALETTE = "PATCH_COLOR_PALETTE"
export const DELETE_COLOR_PALETTE = "DELETE_COLOR_PALETTE"